/**
 * PostHog project constants shared by the browser and server runtimes.
 *
 * The token is public by design (it only allows ingest), but it needs to be
 * readable from both sides: the browser init uses it as the API key, and the
 * server uses it to build the `ph_<token>_posthog` cookie name so server-side
 * exceptions stitch onto the same person as client-side ones.
 */

export const POSTHOG_PROJECT_TOKEN =
  "phc_CoU6p1XZv62l9TmFXWRSYpcs0p060G2gyTfOjpF6JzX"

/**
 * Browser ingest host — our own reverse proxy, so ad blockers and CSP see a
 * first-party domain.
 */
export const POSTHOG_BROWSER_API_HOST = "https://ph.baerskintactical.com"

/**
 * Server ingest host — talks to PostHog directly. Nothing blocks a server-side
 * request, so the proxy hop would only add latency and a failure mode.
 */
export const POSTHOG_SERVER_API_HOST = "https://us.i.posthog.com"

export const POSTHOG_UI_HOST = "https://us.posthog.com"

/** Cookie posthog-js writes the anonymous/identified distinct id into. */
export const POSTHOG_COOKIE_NAME = `ph_${POSTHOG_PROJECT_TOKEN}_posthog`
